import { getBgColor } from "@/src/helpers";
import { IWPLink } from "@/src/types";
import { MainSection } from "@/styles/global";
import React from "react";
import S from "./IconBlock.styled";
import LogoIcon from "@/assets/emblem.svg";
import BlackLogoIcon from "@/assets/emblem-black.svg";
import InfoIcon from "@/assets/info.svg";
import QuoteIcon from "@/assets/quote.svg";
import Button from "@/components/global-components/Button";

export type IconBlockProps = {
  icon: string;
  backgroundColor: string;
  title: string;
  text: string;
  link: IWPLink;
};

const IconBlock: React.FC<IconBlockProps> = ({
  icon,
  title,
  text,
  link,
  backgroundColor,
}) => {
  const renderIcon = (icon: string) => {
    if (icon === "logo") {
      if (backgroundColor === "standard" || backgroundColor === "purple") {
        return <LogoIcon />;
      }
      return <BlackLogoIcon />;
    }
    if (icon === "info") {
      return <InfoIcon />;
    }
    if (icon === "quote") {
      return <QuoteIcon />;
    }
    return null;
  };

  return (
    <MainSection $bgColor={getBgColor("dark", backgroundColor)}>
      <S.Inner $icon={icon}>
        <S.IconWrapper $icon={icon}>{renderIcon(icon)}</S.IconWrapper>
        <S.TextWrapper>
          {title && <S.Title $bgColor={backgroundColor}>{title}</S.Title>}
          {text && <S.Text $bgColor={backgroundColor}>{text}</S.Text>}
          {link && (
            <S.LinkWrapper $icon={icon}>
              <Button
                link={link}
                type="textLink"
                arrow
                color={
                  backgroundColor === "purple" || backgroundColor === "standard"
                    ? "light"
                    : "dark"
                }
              />
            </S.LinkWrapper>
          )}
        </S.TextWrapper>
      </S.Inner>
    </MainSection>
  );
};

export default IconBlock;
